// Shared mapping for the /our-clients client list API response. Used on the
// server (initial render) and on the client (pagination refetch) so both paths
// produce identical props. Extracted verbatim from the former MainPage logic.

export interface ClientItem {
  clientLogo: string;
  tagLine: string;
  smallOverview: string;
}

export interface MappedClientData {
  brandsCategory: any;
  brandsItems: ClientItem[];
  startupsCategory: any;
  startupsItems: ClientItem[];
  enterpriseCategory: any;
  enterpriseItems: ClientItem[];
}

export function mapClientListResult(result: any): MappedClientData | null {
  if (!result?.success || !result?.data) return null;

  const baseURL = result?.data?.baseUrl || "";
  const brandsCat = result.data?.items[0];
  const startupsCat = result?.data?.items[1];
  const enterpriseCat = result?.data?.items[2];

  const brandsItems = (brandsCat?.items || [])?.map((item: any) => ({
    clientLogo: `${baseURL}${item.clientLogo || item.logo || ""}`,
    tagLine:
      item.tagLine || item.tagline || item.companyName || "Valued Client",
    smallOverview: item.smallOverview || item.description || "",
  }));

  const startupsItems = (startupsCat?.items || [])?.map((item: any) => ({
    clientLogo: `${baseURL}${item.clientLogo || item.logo || ""}`,
    tagLine: item.tagLine || item.tagline || "Startup Project",
    smallOverview: item.smallOverview || item.description || "",
  }));

  const enterpriseItems = (enterpriseCat?.items || [])?.map((item: any) => ({
    clientLogo: `${baseURL}${item.clientLogo || item.logo || ""}`,
    tagLine:
      item.tagLine || item.tagline || item.companyName || "Enterprise Client",
    smallOverview: item.smallOverview || item.description || "",
  }));

  return {
    brandsCategory: brandsCat,
    brandsItems,
    startupsCategory: startupsCat,
    startupsItems,
    enterpriseCategory: enterpriseCat,
    enterpriseItems,
  };
}
